import { render, staticRenderFns } from "./AttributesFormElement.vue?vue&type=template&id=4504776a&"
import script from "./AttributesFormElement.vue?vue&type=script&lang=js&"
export * from "./AttributesFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports